export class AdmittedPetsModel {
    tag_id: number;
    pet_no: number;
    pet_name: string;
    location_id: number;
    sublocation_id: number;
    suffix: string;
    department: string;
    clinic_no: number;
    done_by: string;
    tag_display: string;
    location_code: string;
    location_desc: string;
    sublocation_code: string;
    sublocation_desc: string;
    checkedin: boolean;
    client_no: number;
    first_name: string;
    last_name: string;
    assigned_doctor: string;
    assigned_nurse1: string;
    tagdate: string;
    sublocation_clinic_no: number;

    constructor(
        tag_id: number,
        pet_no: number,
        pet_name: string,
        location_id: number,
        sublocation_id: number,
        suffix: string,
        department: string,
        clinic_no: number,
        done_by: string,
        tag_display: string,
        location_code: string,
        location_desc: string,
        sublocation_code: string,
        sublocation_desc: string,
        checkedin: boolean,
        client_no: number,
        first_name: string,
        last_name: string,
        assigned_doctor: string,
        assigned_nurse1: string,
        tagdate: string,
        sublocation_clinic_no: number
    ) {
        this.tag_id = tag_id;
        this.pet_no = pet_no;
        this.pet_name = pet_name;
        this.location_id = location_id;
        this.sublocation_id = sublocation_id;
        this.suffix = suffix;
        this.department = department;
        this.clinic_no = clinic_no;
        this.done_by = done_by;
        this.tag_display = tag_display;
        this.location_code = location_code;
        this.location_desc = location_desc;
        this.sublocation_code = sublocation_code;
        this.sublocation_desc = sublocation_desc;
        this.checkedin = checkedin;
        this.client_no = client_no;
        this.first_name = first_name;
        this.last_name = last_name;
        this.assigned_doctor = assigned_doctor;
        this.assigned_nurse1 = assigned_nurse1;
        this.tagdate = tagdate;
        this.sublocation_clinic_no = sublocation_clinic_no;
    }
}
